import React from 'react';
import PropTypes from 'prop-types';

import { StarIcon } from 'icons';
import { cx } from 'utility';
import * as styles from './Rating.module.scss';

const propTypes = {
    background: PropTypes.bool,
    className: PropTypes.string,
    rating: PropTypes.number,
};

const defaultProps = {
    background: false,
    className: '',
    rating: 1,
};

function getClasses({ className, background, rating }) {
    const classes = cx(
        className,
        styles['rating'],
        background && styles['ratingOnBackground'],
        styles[`rating${rating}`],
    );

    return classes || undefined;
}

function Rating({
    background,
    className,
    rating,
}) {
    const classes = getClasses({ className, background, rating });

    return (
        <ol className={classes}>
            <li className={styles['item']}>
                <StarIcon className={styles['icon']} />
            </li>
            <li className={styles['item']}>
                <StarIcon className={styles['icon']} />
            </li>
            <li className={styles['item']}>
                <StarIcon className={styles['icon']} />
            </li>
            <li className={styles['item']}>
                <StarIcon className={styles['icon']} />
            </li>
            <li className={styles['item']}>
                <StarIcon className={styles['icon']} />
            </li>
        </ol>
    );
}

Rating.propTypes = propTypes;
Rating.defaultProps = defaultProps;

export { Rating };
